import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initDatadogCatchError } from "./datadog-rum-catch-error.ts";
import { initDatadogRum } from "./datadog-rum.ts";
import "./i18n/i18n.ts";
import "./index.css";
import auth0Client from "./auth0.ts";
import { App } from "./root.tsx";

const rootElt = document.getElementById("root");

initDatadogRum();
initDatadogCatchError();

if (rootElt) {
  auth0Client.getInstance().then(() => {
    createRoot(rootElt).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
}
